import AOS from 'aos';
import 'jquery-nice-select/js/jquery.nice-select.min';

// AOS init
AOS.init({ once: true });


$(document).ready(function() {
    $('select').niceSelect();
});

document.addEventListener('DOMContentLoaded', () => {
  const SCROLL_OFFSET = 200; 

  const smoothScrollTo = (hash) => {
    if (!hash || hash === '#') return;

    let targetElement = null;
    try {
      targetElement = document.querySelector(hash);
    } catch (e) {
      return;
    }

    if (targetElement) {
      const elementPosition = targetElement.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.scrollY - SCROLL_OFFSET;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const anchorLinks = document.querySelectorAll('a[href^="#"]');
  
  anchorLinks.forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const hash = this.getAttribute('href');
      const targetElement = document.querySelector(hash);

      if (targetElement) {
        e.preventDefault();
        smoothScrollTo(hash);
        
        if (history.pushState) {
          history.pushState(null, null, hash);
        } else {
          window.location.hash = hash;
        }
      }
    });
  });

  if (window.location.hash) {
    setTimeout(() => {
      window.scrollTo(0, 0); 
      smoothScrollTo(window.location.hash);
    }, 10);
  }
});